import type { TLanguageCode } from "countries-list";

import config from "@/constants/config";

export const isLanguageValid = (
  language: string,
): language is TLanguageCode => {
  return config.appConfig.validLanguages.includes(language);
};
